export default __webpack_public_path__ + "static/media/Mercenary's Legguards of the Yellow Spring.567d81c9.jpg";